import { VenueStatus, VenueType } from "./types";
import type { VenueStatusFilter, VenueTypeFilter } from "./types";

export const VENUES_LIST_QUERY_KEY = ["admin", "venues", "list"] as const;
export const VENUE_DETAIL_QUERY_KEY = ["admin", "venues", "detail"] as const;

export const DEFAULT_PAGE_SIZE = 25;
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Status options for the filter dropdown. `all` first (default), then
 * the lifecycle in the order an operator scans it. Mirrors the order in
 * the API's `VenueStatus` enum so the list reads naturally.
 */
export const VENUE_STATUS_FILTERS: readonly VenueStatusFilter[] = [
  "all",
  VenueStatus.PENDING_APPROVAL,
  VenueStatus.ACTIVE,
  VenueStatus.CHANGES_REQUESTED,
  VenueStatus.SUSPENDED,
  VenueStatus.REJECTED,
];

export const VENUE_TYPE_FILTERS: readonly VenueTypeFilter[] = [
  "all",
  VenueType.GYM,
  VenueType.SPA,
  VenueType.GYM_AND_SPA,
];
